import { render, staticRenderFns } from "./commoditiesEdit.vue?vue&type=template&id=400d6389&scoped=true"
import script from "./commoditiesEdit.vue?vue&type=script&lang=js"
export * from "./commoditiesEdit.vue?vue&type=script&lang=js"
import style0 from "./commoditiesEdit.vue?vue&type=style&index=0&id=400d6389&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d6389",
  null
  
)

export default component.exports